(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-form"] && !Shopify.designMode) return;
  try {
    if (!window.cartMusicPreviewVisibilityBound) {
    window.cartMusicPreviewVisibilityBound = true;

    const cartMusicPreviewIsPending = preview => {
      const loadingText = (preview.textContent || '').trim().toLowerCase();
      return preview.matches('[aria-busy="true"]')
        || Boolean(preview.querySelector('[aria-busy="true"], [data-music-preview-loading], .cart-music-preview__loading'))
        || loadingText.includes('loading music');
    };

    const syncCartMusicPreviewVisibility = scope => {
      const previews = [];
      if (scope instanceof Element && scope.matches('.cart-music-previews')) previews.push(scope);
      if (scope instanceof Document || scope instanceof Element) {
        previews.push(...scope.querySelectorAll('.cart-music-previews'));
      }

      previews.forEach(preview => {
        const ready = Boolean(preview.querySelector('.cart-music-preview')) && !cartMusicPreviewIsPending(preview);
        preview.hidden = !ready;
      });
    };

    syncCartMusicPreviewVisibility(document);

    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.target instanceof Element) {
          syncCartMusicPreviewVisibility(mutation.target.closest('.cart-music-previews') || mutation.target);
        }
        mutation.addedNodes.forEach(node => {
          if (node instanceof Element) syncCartMusicPreviewVisibility(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!window.cartMusicPreviewNavigationDisabled) {
    window.cartMusicPreviewNavigationDisabled = true;
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('.cart-music-preview__link')) {
        event.preventDefault();
      }
    }, true);
  }

	if (!window.cartLineItemDetailsOutsideClickBound) {
	  window.cartLineItemDetailsOutsideClickBound = true;

	  const positionCartLineItemDetails = details => {
	    const panel = details.querySelector('.cart-line-item-details__panel');
	    const group = details.closest('.cart-item-music-group');
	    if (!panel || !group) return;

	    if (!window.matchMedia('(max-width: 749px)').matches || !details.open) {
	      panel.style.removeProperty('--cart-details-mobile-offset');
	      panel.style.removeProperty('--cart-details-mobile-width');
	      return;
	    }

	    const detailsRect = details.getBoundingClientRect();
	    const groupRect = group.getBoundingClientRect();
	    const inset = 12;
	    panel.style.setProperty('--cart-details-mobile-offset', `${groupRect.left + inset - detailsRect.left}px`);
	    panel.style.setProperty('--cart-details-mobile-width', `${groupRect.width - (inset * 2)}px`);
	  };

	  document.addEventListener('toggle', event => {
	    if (event.target instanceof HTMLDetailsElement && event.target.matches('.cart-line-item-details')) {
	      positionCartLineItemDetails(event.target);
	    }
	  }, true);

	  document.addEventListener('click', event => {
	    document.querySelectorAll('.cart-line-item-details[open]').forEach(details => {
	      if (!details.contains(event.target)) details.removeAttribute('open');
	    });
	  });

	  window.addEventListener('resize', () => {
	    document.querySelectorAll('.cart-line-item-details[open]').forEach(positionCartLineItemDetails);
	  });
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-music-previews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('music-preview-card')) {
    customElements.define('music-preview-card', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.requested === 'true') return;
        this.dataset.requested = 'true';
        this.loadMetadata();
      }

      async loadMetadata() {
        try {
          const response = await fetch('https://app.publishmusic.com/api/shopify/music-preview', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ url: this.dataset.url })
          });
          if (!response.ok) throw new Error('Music metadata request failed');
          const metadata = await response.json();
          if (!metadata.ok || !metadata.title || !metadata.artwork_url) throw new Error('Music metadata is incomplete');

          const title = this.querySelector('.cart-music-preview__title');
          const meta = this.querySelector('.cart-music-preview__meta');
          const artwork = this.querySelector('.cart-music-preview__artwork');
          const link = this.querySelector('.cart-music-preview__link');
          const templateName = {
            single: 'singleBy',
            song: 'songBy',
            album: 'albumBy',
            profile: 'profileOf'
          }[metadata.type] || 'singleBy';

          title.textContent = metadata.title;
          meta.textContent = (this.dataset[templateName] || '').replace('%%ARTIST%%', metadata.artist || '');
          artwork.alt = metadata.title;
          artwork.src = metadata.artwork_url;
          link.href = metadata.canonical_url || this.dataset.url;
          this.dataset.loaded = 'true';
        } catch (error) {
          this.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pm-native-options"] && !Shopify.designMode) return;
  try {
    (function (global) {
  const flatten = (elements, ancestors = []) => elements.flatMap(element => element.elements
    ? flatten(element.elements, [...ancestors, element])
    : [{ ...element, ancestors }]);

  function visible(element, state, variantTitle) {
    const evaluate = item => {
      if (!item.conditionalField || !item.clo) return true;
      const tests = item.clo.whens.map(when => {
        const values = when.select === 'shopify_variant' ? [variantTitle] : [].concat(state[when.select] || []);
        if (when.where === 'EQUALS') return values.includes(when.value);
        if (when.where === 'CONTAINS') return values.some(value => String(value).includes(when.value));
        throw new Error(`Unsupported condition: ${when.where}`);
      });
      const match = item.clo.match === 'any' ? tests.some(Boolean) : tests.every(Boolean);
      return item.clo.display === 'hide' ? !match : match;
    };
    return [...(element.ancestors || []), element].every(evaluate);
  }

  function defaults(fields) {
    return Object.fromEntries(fields.map(field => [field.id, field.default_value || []]));
  }

  function selection(fields, state, variantTitle) {
    const properties = {};
    const addons = [];
    for (const field of fields) {
      if (field.type === 'paragraph' || !visible(field, state, variantTitle)) continue;
      const values = [].concat(state[field.id] || []).map(value => String(value).trim()).filter(Boolean);
      if (!values.length) continue;
      properties[field.label_on_cart || field.label] = values.join(', ');
      if (field.addon_product?.variant_id) addons.push({ ...field.addon_product, label: field.label });
      for (const option of field.option_values || []) {
        if (values.includes(option.value) && option.variant_id) addons.push({ ...option, label: option.value });
      }
    }
    return { properties, addons };
  }

  function items(variant, quantity, properties, addons, group, sellingPlan) {
    const parent = { id: Number(variant.id), quantity, properties: { ...properties } };
    if (sellingPlan) parent.selling_plan = Number(sellingPlan);
    if (!addons.length) return [parent];
    parent.properties._pm_group = group;
    parent.properties._pm_role = 'parent';
    return [parent, ...addons.map(addon => ({
      id: Number(addon.variant_id), quantity,
      properties: {
        _pm_group: group,
        _pm_role: 'addon',
        _pm_parent_variant: String(variant.id),
        _pm_addon: addon.label
      }
    }))].reverse();
  }

  const core = { flatten, visible, defaults, selection, items };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  else global.PMNativeOptionsCore = core;
})(typeof window === 'undefined' ? globalThis : window);

(() => {
  const core = window.PMNativeOptionsCore;
  const API = 'https://app.publishmusic.com/api/shopify/';

  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function safeUrl(value) {
    try {
      const parsed = new URL(value);
      return ['https:', 'http:'].includes(parsed.protocol) ? parsed.href : '';
    } catch { return ''; }
  }

  function paragraph(html) {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    for (const element of [...template.content.querySelectorAll('*')]) {
      if (!['P', 'H3', 'SPAN', 'STRONG', 'EM', 'B', 'I', 'BR', 'A'].includes(element.tagName)) {
        element.replaceWith(document.createTextNode(element.textContent));
        continue;
      }
      const href = element.tagName === 'A' ? safeUrl(element.getAttribute('href')) : '';
      for (const attribute of [...element.attributes]) element.removeAttribute(attribute.name);
      if (href) {
        element.href = href;
        element.target = '_blank';
        element.rel = 'noopener noreferrer';
      }
    }
    return template.content;
  }

  function readJson(root, selector) {
    return JSON.parse(root.querySelector(selector).textContent);
  }

  function mount(root) {
    if (root.dataset.pmMounted) return;
    root.dataset.pmMounted = 'true';
    const catalog = readJson(root, '[data-pm-catalog]');
    const config = catalog[root.dataset.productHandle];
    if (!config) { root.remove(); return; }
    const product = readJson(root, '[data-pm-product]');
    const texts = readJson(root, '[data-pm-texts]');
    const query = new URLSearchParams(window.location.search);
    const prefills = {
      email: String(query.get('email') || '').trim(),
      link: String(query.get('link') || '').trim()
    };
    const scope = root.closest('product-page') || root.closest('section') || document;
    const form = [...scope.querySelectorAll('form[action*="/cart/add"]')].find(candidate =>
      !/installment|instalment/i.test(candidate.getAttribute('id') || '') && candidate.querySelector('[name="id"]'));
    const content = root.querySelector('[data-pm-fields]');
    const status = root.querySelector('[data-pm-status]');
    if (!form) { status.textContent = texts.missing_form; return; }
    const formId = form.getAttribute('id') || `${root.id}-form`;
    form.setAttribute('id', formId);
    const fields = core.flatten(config.fields);
    const records = new Map();
    let conflict = false;
    let busy = false;
    let selectedArtworkUrl = '';
    let musicSelectionKey = '';

    function metadataRecord(kind) {
      const aliases = {
        genre: ['genre', 'music genre'],
        similar_artists: ['similar artists', 'similar artist'],
        instagram_username: ['instagram', 'instagram username']
      };
      const field = fields.find(item => {
        const label = String(item.label_on_cart || item.label || '').trim().toLowerCase();
        return aliases[kind].includes(label);
      });
      return field ? records.get(field.id) : null;
    }

    function applyMusicPrefill(selectionKey, prefill) {
      const key = String(selectionKey || '').trim();
      if (!key || !prefill || typeof prefill !== 'object') return;
      const changedSelection = Boolean(musicSelectionKey && musicSelectionKey !== key);
      const firstSelection = !musicSelectionKey;
      if (!firstSelection && !changedSelection) return;
      const values = {
        genre: String(prefill.genre || '').trim(),
        similar_artists: (Array.isArray(prefill.similar_artists) ? prefill.similar_artists : [])
          .map(value => String(value || '').trim()).filter(Boolean).slice(0, 3).join(', '),
        instagram_username: String(prefill.instagram_username || '').trim()
      };
      for (const [kind, value] of Object.entries(values)) {
        const input = metadataRecord(kind)?.inputs?.[0];
        if (!input) continue;
        const current = input.value.trim();
        const previousAutoValue = input.dataset.pmAutofillValue || '';
        if (!value) {
          if (changedSelection && previousAutoValue && current === previousAutoValue) {
            input.value = '';
            delete input.dataset.pmAutofillValue;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          continue;
        }
        if (firstSelection && current) continue;
        input.dataset.pmAutofilling = 'true';
        input.value = value;
        input.dataset.pmAutofillValue = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        delete input.dataset.pmAutofilling;
      }
      musicSelectionKey = key;
    }

    function updateCdArtwork() {
      root.querySelectorAll('[data-pm-cd-preview]').forEach(preview => {
        const placeholder = preview.querySelector('[data-pm-cd-placeholder]');
        const artworkDisc = preview.querySelector('[data-pm-cd-artwork-disc]');
        const hasArtwork = Boolean(selectedArtworkUrl);
        placeholder.hidden = hasArtwork;
        artworkDisc.hidden = !hasArtwork;
        artworkDisc.style.backgroundImage = hasArtwork ? `url(${JSON.stringify(selectedArtworkUrl)})` : '';
      });
    }

    root.addEventListener('pm:music-preview', event => {
      selectedArtworkUrl = safeUrl(event.detail?.artworkUrl || '');
      updateCdArtwork();
    });

    function hasGlobo() {
      return Boolean(scope.querySelector('.gpo-app:not(.pm-native-options)'));
    }

    function checkConflict() {
      conflict = hasGlobo();
      status.textContent = conflict ? texts.globo_active : '';
      status.classList.toggle('pm-option-setup', conflict);
      for (const record of records.values()) {
        for (const input of record.inputs) input.disabled = conflict || record.wrapper.hidden;
      }
      return conflict;
    }

    function state() {
      return Object.fromEntries(fields.map(field => {
        const record = records.get(field.id);
        const inputs = record?.inputs || [];
        if (field.type === 'radio' || field.type === 'checkbox') return [field.id, inputs.filter(input => input.checked).map(input => input.value)];
        if (field.type === 'file') return [field.id, inputs[0]?.files[0]?.name || ''];
        return [field.id, inputs[0]?.value || ''];
      }));
    }

    function selectedVariant() {
      const variantControls = [...scope.querySelectorAll('select.product-variant-container')];
      if (variantControls.length) {
        const selected = variantControls.map(control => control.value);
        const variant = product.variants.find(item => selected.every((value, index) => item.options[index] === value));
        if (variant) return variant;
      }
      const id = new FormData(form).get('id');
      return product.variants.find(variant => String(variant.id) === String(id)) || (product.variants.length === 1 ? product.variants[0] : null);
    }

    function update() {
      const current = state();
      const variant = selectedVariant();
      for (const field of fields) {
        const record = records.get(field.id);
        record.wrapper.hidden = !core.visible(field, current, variant?.title || '');
        for (const input of record.inputs) input.disabled = conflict || record.wrapper.hidden;
        if (record.selected) {
          const selectedText = [].concat(current[field.id] || []).join(', ');
          if (record.selected.textContent !== selectedText) record.selected.textContent = selectedText;
          record.selected.hidden = !record.selected.textContent;
        }
      }
    }

    function amount(addon) {
      const wrapper = node('span', 'pm-option-amount');
      const price = Number(addon.variant_price || 0);
      const renderMoney = (value, className = '') => {
        const moneyWrapper = node('span', `metafield-money${className ? ` ${className}` : ''}`);
        const money = node('span', 'money conversion-bear-money');
        money.dataset.amount = String(value);
        money.textContent = new Intl.NumberFormat('en', { style: 'currency', currency: root.dataset.baseCurrency || 'EUR' }).format(value);
        moneyWrapper.append(money);
        return moneyWrapper;
      };
      if (addon.price_format === 'discount_compare') {
        const discountedPrice = Math.round(price * (100 - Number(addon.discount_percent || 0))) / 100;
        wrapper.append(
          document.createTextNode(' (+ '),
          renderMoney(discountedPrice, 'pm-option-discounted-price'),
          document.createTextNode(' '),
          renderMoney(price, 'pm-option-original-price'),
          document.createTextNode(')')
        );
      } else if (addon.price_format === 'plain_plus') wrapper.append(document.createTextNode(' + '), renderMoney(price));
      else wrapper.append(document.createTextNode(' (+ '), renderMoney(price), document.createTextNode(')'));
      return wrapper;
    }

    function tooltip(text) {
      const button = node('button', 'pm-option-tooltip');
      button.type = 'button';
      button.append(node('span', '', 'i'), node('span', 'pm-option-tooltip-text', text));
      button.setAttribute('aria-label', text);
      return button;
    }

    const initial = core.defaults(fields);
    for (const field of fields) {
      const isChoice = field.type === 'radio' || field.type === 'checkbox';
      const wrapper = node(isChoice ? 'fieldset' : 'div', 'pm-option');
      wrapper.dataset.pmField = field.id;
      if (field.type === 'checkbox') wrapper.classList.add('pm-option-checkbox');
      const id = `${root.id}-${field.id}`;
      const record = { wrapper, inputs: [], error: node('p', 'pm-option-error') };
      record.error.hidden = true;
      record.error.id = `${id}-error`;
      record.error.setAttribute('role', 'alert');
      records.set(field.id, record);
      if (field.type === 'paragraph') {
        wrapper.classList.add('pm-option-paragraph');
        wrapper.append(paragraph(field.text));
        content.append(wrapper);
        continue;
      }

      if (!field.hidden_label) {
        const label = node(isChoice ? 'legend' : 'label', 'pm-option-label');
        label.append(node('span', '', field.label));
        if (!isChoice) label.htmlFor = id;
        if (field.required) label.append(node('span', 'pm-option-required', '*'));
        if (field.addon_product) label.append(amount(field.addon_product));
        if (field.helptext && field.helptext_position === 'tooltip') label.append(tooltip(field.helptext));
        wrapper.append(label);
      }

      const help = field.helptext ? node('span', 'pm-option-help', field.helptext) : null;
      if (help) help.id = `${id}-help`;
      if (help && field.helptext_position === 'below_label') wrapper.append(help);

      if (isChoice) {
        for (const option of field.option_values || []) {
          const choice = node('label', 'pm-option-choice');
          const input = node('input');
          input.type = field.type;
          input.id = `${id}-${option.id}`;
          input.name = `properties[${field.label_on_cart || field.label}]`;
          input.value = option.value;
          input.checked = [].concat(initial[field.id]).includes(option.value);
          input.setAttribute('form', formId);
          const copy = node('span', 'pm-option-choice-copy');
          copy.append(node('span', '', option.value));
          if (option.variant_id) copy.append(amount(option));
          choice.append(input);
          if (option.preview === 'cd') {
            const thumbnail = node('span', 'pm-option-thumbnail pm-option-cd-thumbnail');
            thumbnail.setAttribute('aria-hidden', 'true');
            thumbnail.dataset.pmCdPreview = '';
            const placeholder = node('span', 'pm-option-cd-disc pm-option-cd-placeholder');
            placeholder.dataset.pmCdPlaceholder = '';
            const artworkDisc = node('span', 'pm-option-cd-disc pm-option-cd-artwork-disc');
            artworkDisc.dataset.pmCdArtworkDisc = '';
            placeholder.hidden = Boolean(selectedArtworkUrl);
            artworkDisc.hidden = !selectedArtworkUrl;
            if (selectedArtworkUrl) artworkDisc.style.backgroundImage = `url(${JSON.stringify(selectedArtworkUrl)})`;
            thumbnail.append(placeholder, artworkDisc);
            choice.append(thumbnail);
          } else if (safeUrl(option.url)) {
            const thumbnail = node('img', 'pm-option-thumbnail');
            thumbnail.src = safeUrl(option.url);
            thumbnail.alt = '';
            thumbnail.loading = 'lazy';
            choice.append(thumbnail);
          }
          choice.append(copy);
          wrapper.append(choice);
          if (option.helptext) wrapper.append(node('span', 'pm-option-help pm-option-choice-help', option.helptext));
          record.inputs.push(input);
        }
      } else if (field.type === 'file') {
        const dropzone = node('label', 'pm-option-upload');
        dropzone.htmlFor = id;
        const success = node('span', 'pm-option-file-success', '✓');
        success.hidden = true;
        success.setAttribute('aria-hidden', 'true');
        dropzone.append(node('span', 'pm-option-file-button', texts.choose_file));
        const filename = node('span', 'pm-option-file-name', texts.drop_file);
        filename.setAttribute('aria-live', 'polite');
        const input = node('input');
        input.type = 'file';
        input.id = id;
        input.name = `properties[${field.label_on_cart || field.label}]`;
        input.accept = (field.allowed_extensions || []).map(extension => `.${extension}`).join(',');
        input.setAttribute('form', formId);
        input.addEventListener('change', () => {
          const file = input.files[0];
          dropzone.classList.toggle('has-file', Boolean(file));
          success.hidden = !file;
          filename.textContent = file ? `${texts.file_ready}: ${file.name}` : texts.drop_file;
        });
        dropzone.prepend(success);
        dropzone.append(filename, input);
        wrapper.append(dropzone);
        record.inputs.push(input);
      } else {
        const anchor = node('div', 'pm-option-anchor');
        const input = node(field.type === 'textarea' ? 'textarea' : 'input', 'pm-option-input');
        if (input.tagName === 'INPUT') input.type = 'text';
        const propertyLabel = String(field.label_on_cart || field.label || '').trim();
        const propertyKey = propertyLabel.toLowerCase();
        input.id = id;
        input.name = `properties[${propertyLabel}]`;
        input.placeholder = field.placeholder || '';
        input.setAttribute('form', formId);
        input.setAttribute('aria-required', String(Boolean(field.required)));
        input.setAttribute('aria-describedby', `${help ? help.id + ' ' : ''}${record.error.id}`);
        if (propertyKey === 'email' || propertyKey === 'email address') {
          if (input.tagName === 'INPUT') input.type = 'email';
          input.inputMode = 'email';
          input.autocomplete = 'email';
          if (prefills.email && prefills.email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prefills.email)) {
            input.value = prefills.email;
          }
        }
        if (propertyKey === 'instagram') input.autocomplete = 'off';
        anchor.append(input);
        wrapper.append(anchor);
        record.inputs.push(input);
        if (config.platform && propertyKey === 'link') {
          enhanceSearch(input, anchor, wrapper, config.platform, texts, prefills.link, applyMusicPrefill);
        }
      }
      if (help && !['below_label', 'tooltip'].includes(field.helptext_position)) wrapper.append(help);
      wrapper.append(record.error);
      content.append(wrapper);
    }

    for (const kind of ['genre', 'similar_artists', 'instagram_username']) {
      const input = metadataRecord(kind)?.inputs?.[0];
      input?.addEventListener('input', () => {
        if (!input.dataset.pmAutofilling) delete input.dataset.pmAutofillValue;
      });
    }

    root.addEventListener('input', update);
    root.addEventListener('change', update);
    scope.addEventListener('change', () => { update(); requestAnimationFrame(update); });
    scope.addEventListener('variant:change', update);
    const controller = new AbortController();
    const signal = controller.signal;

    function validate(variant) {
      let firstInvalid = null;
      const current = state();
      for (const field of fields) {
        const record = records.get(field.id);
        record.error.hidden = true;
        if (!record.inputs.length || record.wrapper.hidden) continue;
        const input = record.inputs[0];
        const values = [].concat(current[field.id] || []).filter(value => String(value).trim());
        let message = '';
        if (field.required && !values.length) message = texts.required;
        if (field.type === 'file' && input.files[0]) {
          const extension = input.files[0].name.split('.').pop().toLowerCase();
          if (field.allowed_extensions?.length && !field.allowed_extensions.includes(extension)) message = texts.invalid_file;
        }
        if (input.dataset.pmSearchPlatform && values.length) {
          const link = values[0];
          const isUri = input.dataset.pmSearchPlatform === 'spotify' && /^spotify:(track|album|artist):[a-zA-Z0-9]+$/.test(link);
          if (!safeUrl(link) && !isUri) message = texts.select_link;
          if (input.dataset.pmSearchPlatform === 'apple_music' && safeUrl(link)
            && !['music.apple.com', 'itunes.apple.com'].includes(new URL(link).hostname)) message = texts.select_link;
        }
        if (message) {
          record.error.textContent = message;
          record.error.hidden = false;
          if (!firstInvalid) firstInvalid = input;
        }
      }
      if (firstInvalid) {
        firstInvalid.focus();
        firstInvalid.closest('.pm-option').scrollIntoView({ block: 'center', behavior: 'smooth' });
        return false;
      }
      if (!variant?.available) { status.textContent = texts.unavailable; return false; }
      return true;
    }

    async function add() {
      if (busy) return;
      update();
      const variant = selectedVariant();
      if (!validate(variant)) return;
      const formData = new FormData(form);
      const quantity = Math.max(1, Math.floor(Number(formData.get('quantity') || 1)));
      const { properties, addons } = core.selection(fields, state(), variant.title);
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string' && value && !(match[1] in properties)) properties[match[1]] = value;
      }
      const sellingPlan = formData.get('selling_plan') || '';
      if (variant.requires_selling_plan && !sellingPlan) { status.textContent = texts.subscription_required; return; }
      const selectedFiles = fields.filter(field => field.type === 'file' && !records.get(field.id).wrapper.hidden)
        .map(field => ({ key: field.label_on_cart || field.label, file: records.get(field.id).inputs[0].files[0] }))
        .filter(item => item.file);
      if (selectedFiles.length && addons.length) { status.textContent = texts.file_addon_conflict; return; }
      const group = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const items = core.items(variant, quantity, properties, addons, group, sellingPlan);
      const buttons = [...form.querySelectorAll('[type="submit"]')];
      const disabledStates = buttons.map(button => button.disabled);
      const addButton = form.querySelector('[name="add"], [data-product-add], button[type="submit"], input[type="submit"]');
      const addButtonState = addButton ? {
        html: addButton.tagName === 'BUTTON' ? addButton.innerHTML : '',
        value: addButton.tagName === 'INPUT' ? addButton.value : ''
      } : null;
      busy = true;
      buttons.forEach(button => { button.disabled = true; });
      status.textContent = '';
      if (addButton) {
        addButton.classList.add('pm-add-button-loading');
        if (addButton.tagName === 'INPUT') addButton.value = texts.adding;
        else addButton.textContent = texts.adding;
      }
      root.setAttribute('aria-busy', 'true');
      try {
        let body;
        let headers;
        if (selectedFiles.length) {
          body = new FormData();
          body.set('id', String(variant.id));
          body.set('quantity', String(quantity));
          if (sellingPlan) body.set('selling_plan', String(sellingPlan));
          const fileKeys = new Set(selectedFiles.map(item => item.key));
          for (const [key, value] of Object.entries(properties)) if (!fileKeys.has(key)) body.set(`properties[${key}]`, value);
          for (const { key, file } of selectedFiles) body.set(`properties[${key}]`, file, file.name);
          headers = { Accept: 'application/json' };
        } else {
          body = JSON.stringify({ items });
          headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        }
        const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', body, headers, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || texts.cart_error);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || texts.cart_error;
        busy = false;
        root.removeAttribute('aria-busy');
        buttons.forEach((button, index) => { button.disabled = disabledStates[index]; });
        if (addButton && addButtonState) {
          addButton.classList.remove('pm-add-button-loading');
          if (addButton.tagName === 'INPUT') addButton.value = addButtonState.value;
          else addButton.innerHTML = addButtonState.html;
        }
      }
    }

    form.addEventListener('submit', event => {
      if (conflict) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      add();
    }, { capture: true, signal });
    form.addEventListener('click', event => {
      const button = event.target.closest('button[type="submit"],input[type="submit"],button[name="add"]');
      if (!button || button.disabled || conflict) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      add();
    }, { capture: true, signal });

    const observer = new MutationObserver(() => {
      if (!root.isConnected) { observer.disconnect(); controller.abort(); return; }
      const currentConflict = hasGlobo();
      if (currentConflict !== conflict) checkConflict();
      update();
    });
    observer.observe(scope === document ? document.body : scope, { childList: true, subtree: true });
    checkConflict();
    update();
  }

  function enhanceSearch(input, anchor, wrapper, platform, texts, prefillLink, applyPrefill) {
    input.dataset.pmSearchPlatform = platform;
    const searchPlaceholderText = String(texts.search_placeholder || 'Search or paste link');
    input.placeholder = '';
    input.setAttribute('aria-label', searchPlaceholderText);
    input.autocomplete = 'off';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.classList.add('pm-option-search-icon');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<circle cx="10.5" cy="10.5" r="7.5" fill="none" stroke="currentColor" stroke-width="2.1"/><path d="m16 16 5 5" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"/>';
    const visualPlaceholder = node('span', 'pm-option-search-placeholder');
    visualPlaceholder.setAttribute('aria-hidden', 'true');
    const searchWord = searchPlaceholderText.match(/^Search\b/i);
    if (searchWord) {
      visualPlaceholder.append(node('strong', '', searchWord[0]));
      visualPlaceholder.append(document.createTextNode(searchPlaceholderText.slice(searchWord[0].length)));
    } else visualPlaceholder.textContent = searchPlaceholderText;
    const menu = node('div', 'pm-option-results');
    menu.id = `${input.id}-results`;
    menu.setAttribute('role', 'listbox');
    input.setAttribute('aria-controls', menu.id);
    anchor.append(icon, visualPlaceholder, menu);
    const card = node('div', 'pm-option-card');
    card.setAttribute('aria-live', 'polite');
    const artwork = node('img', 'pm-option-artwork');
    artwork.alt = '';
    const copy = node('span', 'pm-option-card-copy');
    const title = node('span', 'pm-option-title');
    const meta = node('span', 'pm-option-meta');
    const change = node('button', 'pm-option-change', texts.change);
    change.type = 'button';
    copy.append(title, meta);
    card.append(artwork, copy, change);
    wrapper.append(card);
    let sequence = 0;
    let timer;
    let controller;
    let active = -1;
    let rows = [];
    let savedPreviewUrl = '';
    let applying = false;

    function syncVisualPlaceholder() {
      visualPlaceholder.hidden = Boolean(input.value);
    }

    function close() {
      menu.classList.remove('is-open');
      rows = [];
      menu.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function cancel() {
      clearTimeout(timer);
      sequence += 1;
      controller?.abort();
    }

    function message(text) {
      rows = [];
      active = -1;
      menu.replaceChildren(node('p', 'pm-option-message', text));
      menu.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function metadata(result) {
      const type = result.type === 'profile' || result.type === 'artist' ? texts.profile : texts[result.type] || texts.song;
      return `${type} ${type === texts.profile ? texts.of : texts.by} ${result.artist || result.title || ''}`;
    }

    function show(result) {
      close();
      const url = safeUrl(result.artwork_url);
      wrapper.closest('[data-pm-native-options]')?.dispatchEvent(new CustomEvent('pm:music-preview', { detail: { artworkUrl: url } }));
      artwork.style.visibility = url ? 'visible' : 'hidden';
      if (url) artwork.src = url;
      else artwork.removeAttribute('src');
      title.textContent = result.title || texts.selected_music;
      meta.textContent = metadata(result);
      anchor.hidden = true;
      card.classList.add('is-visible');
    }

    function choose(result) {
      if (!safeUrl(result.url) && !/^spotify:(track|album|artist):/.test(result.url || '')) return;
      cancel();
      applying = true;
      input.value = result.url;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      applying = false;
      preview(result.url, sequence, result);
    }

    function render(results) {
      rows = [];
      menu.replaceChildren();
      if (!results.length) { message(texts.no_results); return; }
      results.filter(result => safeUrl(result.url)).forEach((result, index) => {
        const row = node('button', 'pm-option-result');
        row.type = 'button';
        row.id = `${menu.id}-${index}`;
        row.setAttribute('role', 'option');
        row.setAttribute('aria-selected', 'false');
        const image = node('img', 'pm-option-artwork');
        image.alt = '';
        const url = safeUrl(result.artwork_url);
        if (url) image.src = url;
        else image.style.visibility = 'hidden';
        const text = node('span', 'pm-option-result-copy');
        text.append(node('span', 'pm-option-title', result.title), node('span', 'pm-option-meta', metadata(result)));
        row.append(image, text);
        row.addEventListener('mousedown', event => event.preventDefault());
        row.addEventListener('click', () => choose(result));
        menu.append(row);
        rows.push(row);
      });
      menu.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    async function search(value, request) {
      controller = new AbortController();
      const requestController = controller;
      const signal = requestController.signal;
      const timeout = setTimeout(() => requestController.abort(), 8000);
      message(texts.searching);
      try {
        const url = new URL(`${API}${platform === 'spotify' ? 'spotify-search' : 'apple-music-search'}`);
        url.searchParams.set('q', value);
        url.searchParams.set(platform === 'spotify' ? 'market' : 'country', platform === 'spotify' ? 'US' : 'us');
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal });
        const data = await response.json();
        if (request !== sequence || input.value.trim() !== value) return;
        if (!response.ok || !data.ok) throw new Error('search');
        render(Array.isArray(data.results) ? data.results : []);
      } catch {
        if (request === sequence) message(texts.search_unavailable);
      } finally { clearTimeout(timeout); }
    }

    async function preview(value, request, immediateResult) {
      if (value === savedPreviewUrl) return;
      savedPreviewUrl = value;
      if (immediateResult) show(immediateResult);
      controller = new AbortController();
      const requestController = controller;
      const signal = requestController.signal;
      const timeout = setTimeout(() => requestController.abort(), 5000);
      try {
        const url = new URL(`${API}music-preview`);
        url.searchParams.set('url', value);
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal });
        const data = await response.json();
        if (request !== sequence || input.value.trim() !== value) return;
        if (response.ok && data.ok) {
          show(data);
          applyPrefill?.(data.canonical_url || value, data.prefill);
        }
      } catch {} finally { clearTimeout(timeout); }
    }

    input.addEventListener('input', () => {
      syncVisualPlaceholder();
      if (applying) return;
      wrapper.closest('[data-pm-native-options]')?.dispatchEvent(new CustomEvent('pm:music-preview', { detail: { artworkUrl: '' } }));
      cancel();
      close();
      card.classList.remove('is-visible');
      anchor.hidden = false;
      const value = input.value.trim();
      if (safeUrl(value) || /^spotify:(track|album|artist):/.test(value)) { preview(value, sequence); return; }
      savedPreviewUrl = '';
      if (value.length >= 2) {
        const request = sequence;
        timer = setTimeout(() => search(value, request), 450);
      }
    });
    input.addEventListener('keydown', event => {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (['ArrowDown', 'ArrowUp'].includes(event.key) && rows.length) {
        event.preventDefault();
        active = (active + (event.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
        rows.forEach((row, index) => { row.classList.toggle('is-active', index === active); row.setAttribute('aria-selected', String(index === active)); });
        input.setAttribute('aria-activedescendant', rows[active].id);
        rows[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (active >= 0 && rows[active]) rows[active].click();
      }
    });
    change.addEventListener('click', () => {
      cancel();
      close();
      savedPreviewUrl = '';
      card.classList.remove('is-visible');
      anchor.hidden = false;
      input.focus();
      input.select();
    });
    document.addEventListener('click', event => { if (!anchor.contains(event.target)) close(); });
    if (prefillLink && (safeUrl(prefillLink) || /^spotify:(track|album|artist):/.test(prefillLink))) {
      input.value = prefillLink;
      syncVisualPlaceholder();
      preview(prefillLink, sequence);
    }
    syncVisualPlaceholder();
  }

  function initialize() {
    document.querySelectorAll('[data-pm-native-options]').forEach(mount);
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
